/**
 * LocationWrapper
 *
 * Wrapper component that provides location context and layout
 * to child components. Navigation is handled by the SpatialNavbar
 * breadcrumb (Back, location name, Campus link), so no duplicate
 * header is rendered here.
 */

import React from 'react';
import { LocationWrapperProps } from '../../types/spatial';
import { LocationProvider } from './LocationContext';

/**
 * LocationWrapper component
 *
 * Wraps location content with:
 * - Location context provider
 * - Consistent styling and layout
 */
export const LocationWrapper: React.FC<LocationWrapperProps> = ({
  location,
  backgroundColor,
  children,
}) => {
  return (
    <LocationProvider location={location}>
      <div
        className="flex flex-col h-full w-full overflow-hidden"
        style={{ backgroundColor }}
        data-location={location}
        data-testid={`location-wrapper-${location}`}
      >
        {/* Location Content */}
        <div className="flex-1 overflow-auto">
          {children}
        </div>
      </div>
    </LocationProvider>
  );
};

export default LocationWrapper;
